
        import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/plugins/truncate/js/init';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/components/truncater/js/truncater';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/widgets/table-of-content/js/table-of-content';
  
const main = (UX) => {
    const $truncater = Array.prototype.slice.call(document.getElementsByClassName('js--truncate')),
        $tocJs = Array.prototype.slice.call(document.querySelectorAll('.loa, .meta__authors, .to-section'))

try {
        if ($truncater.length ) {
            UX.truncater.init($truncater);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($tocJs.length ) {
            UX.tocJs.init($tocJs);
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        